import imageOne from '@/assets/images/cities/burlington1.jpg'
import imageTwo from '@/assets/images/cities/burlington2.jpg'
import imageThree from '@/assets/images/cities/burlington3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  'city': 'Burlington',
  'writeup': '',
  'notaries': [
    {
      'name': '',
      'open': true,
      'phone': '(289) 975-4566',
      'hours': {
        'monday': '8:00AM to 6:00PM',
        'tuesday': '8:00AM to 6:00PM',
        'wednesday': '8:00AM to 6:00PM',
        'thursday': '8:00AM to 6:00PM',
        'friday': '8:00AM to 6:00PM',
        'saturday': 'By Request',
        'sunday': 'By Request'
      },
      'address': 'Beeforth Road Waterdown Location',
      'notes': ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/burlington.js